/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    string, func, shape, arrayOf, object,
} from 'prop-types';
import CustomsMessageView from './CustomsMessageView';

const PersonalizeMessageCustoms = ({
    message, setMessage, csLabelData, toolbarProps, customCardType,
}) => (
    <CustomsMessageView
        messageData={message}
        setCardMessage={setMessage}
        csLabelData={csLabelData}
        toolbarProps={toolbarProps}
        customCardType={customCardType}
    />
);
PersonalizeMessageCustoms.propTypes = {
    message: object.isRequired,
    setMessage: func.isRequired,
    csLabelData: shape({
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: object,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
    customCardType: string.isRequired,
};
PersonalizeMessageCustoms.defaultProps = {
    toolbarProps: {},
};
export default PersonalizeMessageCustoms;
